import { DetectedWebView } from "@ciaopeople/cp-shatsu/ClientDetection/WebViewDetails.js";
import { CP_EmbedType } from "@mp-commons/modules/ads/adcall/CustomParams.js";
import { AdResumableTriggerBehaviour, ImaControllerFeatures } from "@mp-commons/modules/ads/ima/AbstractImaController.js";
import { MultipleVASTImaAdCallControllerConfig, VASTAdUnitConfig } from "@mp-commons/modules/ads/ima/MultipleVASTImaAdCallController.js";
import { VideoPolicyRules } from "@mp-commons/modules/ads/vprules/VideoPolicyRules.js";

function getStandardFeatures(): ImaControllerFeatures {
  return {
    autoPlayAdBreaks: false,
    styledAds: false,
    vpaid: google.ima.ImaSdkSettings.VpaidMode.ENABLED,
    mediaPreloading: true,
    enableCustomClickTracking: false
  }
}


export function getAdvConfiguration(videoPolicy: VideoPolicyRules,
  embedType: CP_EmbedType,
  vwDetect: DetectedWebView,
  isLazyVideoLoad: boolean,
  inputUnits?: VASTAdUnitConfig[]): MultipleVASTImaAdCallControllerConfig {

  const baseConfig: MultipleVASTImaAdCallControllerConfig = {
    features: getStandardFeatures(),
    responsive: true,
    preload: {
      enable: true,
      time: 10
    },
    adUnits: inputUnits,
    adResumableTriggerBehaviour: AdResumableTriggerBehaviour.DEFER_PREROLL_TRIGGER_TO_FIRST_MIDROLL,
    videoPolicy: videoPolicy
  }

  if (isLazyVideoLoad && embedType != CP_EmbedType.FANPLAYER) {
    baseConfig.ensureResourceLoadAfterPrerollPercentage = 0.8;
  }

  return baseConfig;

}